// removed by extract-text-webpack-plugin
module.exports = {"content":"content___2uEmv","closeIcon":"closeIcon___3n2I-","btnContainer":"btnContainer___1vzPG","title":"title___1sJWJ","select":"select___2tHM8","modelSelect":"modelSelect___2pH2B"};


//////////////////
// WEBPACK FOOTER
// ./src/components/DownloadModel/DownloadModel.module.css
// module id = 201
// module chunks = 0